import React from "react";
import ProjectRequestLine from "./projectRequestLine";

const ProjectRequestLines = ({openRequests, calendar, classSelection, xwidth, pstate, planningsPavingdata }) => {
	return (
		<React.Fragment>
			{openRequests
				.filter(
					x =>
						classSelection.includes("ALL") ||
						classSelection.includes(x.requirement._resclass.id)
				).map(x => (
					<ProjectRequestLine calendar={calendar} xwidth={xwidth} pstate={pstate} data={x} key={x.key} planningsPavingdata={planningsPavingdata} />
				))}
		</React.Fragment>
	);
};

export default ProjectRequestLines;
